module.exports = __webpack_public_path__ + "img/top_txt.08e0bb9c.png";